import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/images/toronto-live-logo.svg';
import SocialList from './SocialList';
import { focusTrap, focusTrapRemove } from '../helpers/focusTrap';

/**
 * Header Component
 */
class Header extends Component {
	openNav = () => {
		this.nav.classList.add('show', 'visible');
		// toggle class to prevent scroll when open on mobile
		document.body.classList.add('no-scroll-mobile');
      focusTrap(this.nav);
	}
   closeNav = () => {
      this.nav.classList.remove('show');
      setTimeout(()=> {
         this.nav.classList.remove('visible');
      },300);
		// toggle class to prevent scroll when open on mobile
		document.body.classList.remove('no-scroll-mobile');
      focusTrapRemove(this.nav);
   }
   keyDownHandler = (e) => {
      e.keyCode === 27 && this.closeNav();
   };
	render() {
		return (
			<header className="header" onKeyDown={this.keyDownHandler}>
				<div className="header__wrapper clearfix">
					<button className="header__button" onClick={this.openNav}></button>
					<NavLink to="/" className="header__logo">
						<img src={Logo} alt="Main website logo"/>
					</NavLink>
					<div className="header__social-list">
						<SocialList />
					</div>
				</div>
				<div className="nav-container" ref={ref => this.nav = ref} tabIndex="-1">
					<nav className="nav">
						
						<a href="/" className="nav__logo">
							<img src={Logo} alt="Main website logo"/>
						</a>
						<ul className="nav__list">
							<li><NavLink to="/" exact={true} className="nav__link" onClick={this.closeNav}>Home</NavLink></li>
							<li><NavLink to="/about" className="nav__link" onClick={this.closeNav}>About</NavLink></li>
							<li><NavLink to="/contact" className="nav__link" onClick={this.closeNav}>Contact</NavLink></li>
						</ul>
						<div className="nav__social-list">
							<SocialList />
						</div>
                  <button className="nav__close-button" onClick={this.closeNav}></button>
					</nav>
					<div className="nav-open-overlay" onClick={this.closeNav}></div>
				</div>
			</header>
		)
	}
}
export default Header;
